import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-talep-olusturuldu',
  templateUrl: './talep-olusturuldu.component.html',
  styleUrls: ['./talep-olusturuldu.component.css']
})
export class TalepOlusturulduComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  talepId: string = null;
  talepNo: string;

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.talepId = params.id;
      this.talepNo = params.talepNo;
    }));
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  showDetails() {
    this.router.navigate(['talep'], {queryParams: {id: this.talepId}});

  }

  showTalepler() {
    this.router.navigate(['talepler']);
  }

  newTalep() {
    this.router.navigate(['talep'], {queryParams: {id: '0'}});
  }
}
